import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";

import {
  AiOutlineUser,
  AiOutlineHeart,
  AiOutlineShoppingCart,
  AiOutlineBars,
  AiOutlineDownSquare,
  AiOutlineMenu,
  AiOutlineLogout,
} from "react-icons/ai";

import { RxCross1 } from "react-icons/rx";
import Button from "./Button";

import { apiURL } from "../api/index";

function Header(props) {
  const Navigate = useNavigate();
  const cartItems = useSelector((state) => state.AddToCart);
  const wishlistItems = useSelector((state) => state.AddToWhishList);
  const [inputText, setInputText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isLogin, setIsLogin] = useState(false);

  const toggleMenuLinks = useRef();
  const toggleSubMenu = useRef();
  const toggleSearch = useRef();
  const sideMenu = useRef();

  function menuToggler() {
    toggleMenuLinks.current.classList.toggle("hidden");
    toggleSubMenu.current.classList.toggle("hidden");
    toggleSearch.current.classList.toggle("hidden");
    toggleSearch.current.classList.add("flex");
    setInputText("");
  }

  function openCategory() {
    sideMenu.current.style.display = "none";
  }

  function TotalCartItems() {
    const CartTotal = cartItems.reduce((total, item) => {
      return total + item.quantity;
    }, 0);
    return CartTotal;
  }

  function TotalWhishlistItems() {
    const WhishlistTotal = wishlistItems.reduce((total, item) => {
      return total + item.quantity;
    }, 0);
    return WhishlistTotal;
  }

  const getNumItemsInCategory = (categoryTitle) => {
    if (categoryTitle === "All Categories") {
      return props.products.length;
    }
    return props.products.filter((item) => item.category === categoryTitle)
      .length;
  };

  const searchTerms = {
    Categories: [
      "Tires",
      "Batteries",
      "Gadgets",
      "Helmets",
      "Motors",
      "HeadLights",
    ],
  };

  function getSuggestions(text) {
    const suggestions = [];
    Object.values(searchTerms).forEach((terms) => {
      const matchingTerms = terms.filter((term) =>
        term.toLowerCase().startsWith(text.toLowerCase())
      );
      suggestions.push(...matchingTerms);
    });
    return suggestions.slice(0, 5);
  }

  const handleInputChange = (event) => {
    const text = event.target.value;
    setInputText(text);

    const newSuggestions = getSuggestions(text);
    setSuggestions(newSuggestions);
  };
  const handleSuggestionClick = (suggestion) => {
    setInputText(suggestion);
    setSuggestions([]);
  };

  const CheckLogin = async () => {
    try {
      const res = await fetch(`${apiURL}/check`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      await res.json();

      setIsLogin(true);
    } catch (error) {
      setIsLogin(false);
    }
  };
  useEffect(() => {
    CheckLogin();
  });

  function logout() {
    fetch(`${apiURL}/logout`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((data) => {
        const result = data.json();
        if (result) {
          Navigate("/login");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <>
      <div className="sticky top-0 bg-primary font-primary font-bold flex-col text-white flex lg:flex lg:flex-row items-start justify-around lg:items-center w-full">
        {/* mobile responsive top header */}
        <div className="flex justify-around w-full lg:w-fit lg:pr-0 pr-4">
          {/* brand */}
          <NavLink to="/" onClick={menuToggler}>
            <div className="flex justify-center items-center">
              <img
                className="bg-choice"
                width="75px"
                src="/images/digitalmechanic.png"
                alt="logo"
              />
              <span className="text-2xl md:text-3xl">DigitalMechanic</span>
            </div>
          </NavLink>

          {/* toggle menu button */}
          <div className="flex justify-center items-center lg:hidden">
            <Button className="bg-secondary rounded" onClick={menuToggler}>
              <AiOutlineMenu size="25" />
            </Button>
          </div>
        </div>
        {/* search box */}
        <div
          ref={toggleSearch}
          className="w-full hidden lg:w-96 justify-center items-center lg:flex"
        >
          <input
            type="text"
            value={inputText}
            onChange={handleInputChange}
            placeholder="Filter Products By Categories..."
            className="w-full text-black font-thin border-gray-300 shadow-sm py-2 px-4 focus:outline-none rounded-l-lg"
          />
          {suggestions.length > 0 && (
            <ul className="absolute md:top-full top-[115px] left-0 right-0 bg-gray-300 rounded-lg shadow-md text-gray-700 border-gray-300 border mt-0 z-10">
              {suggestions.map((suggestion) => (
                <li
                  key={suggestion}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </li>
              ))}
            </ul>
          )}
          <NavLink to={`shop/${inputText}`}>
            <button
              onClick={menuToggler}
              className="font-medium bg-secondary pr-4 pl-4 pt-2 pb-2 rounded-r-lg"
            >
              Search
            </button>
          </NavLink>
        </div>

        {/* right-menus start here */}
        <div
          ref={toggleMenuLinks}
          className="lg:block hidden lg:font-semibold font-medium lg:flex-row flex-col justify-center items-center lg:w-fit w-full"
        >
          <ul className="lg:text-white text-black divide-y lg:divide-y-0 divide-slate-100 flex lg:justify-between items-center justify-center lg:flex-row flex-col w-full">
            {isLogin ? (
              <button className="header-topmenulinks py-2" onClick={logout}>
                <AiOutlineLogout size="25" />
                Logout
              </button>
            ) : (
              <NavLink
                to="/login"
                className="header-topmenulinks py-2"
                onClick={menuToggler}
              >
                <AiOutlineUser size="25" />
                <li>Sign in</li>
              </NavLink>
            )}

            <NavLink
              onClick={menuToggler}
              to="/whishlist"
              className="header-topmenulinks md:m-4 mt-0"
            >
              <AiOutlineHeart size="25" />
              <div className="header-icon py-3 px-2">
                {TotalWhishlistItems()}
              </div>
              <li className="m-2">Whishlist</li>
            </NavLink>
            <NavLink
              to="/cart"
              onClick={menuToggler}
              className="header-topmenulinks md:m-4 mt-0"
            >
              <AiOutlineShoppingCart size="25" />
              <div className="header-icon py-3 px-2">{TotalCartItems()}</div>
              <li className="m-2">Cart</li>
            </NavLink>
          </ul>
        </div>
      </div>
      {/* Sub Menu Header */}
      <div
        ref={toggleSubMenu}
        className="lg:flex hidden font-primary bg-[#eeeeee] w-full justify-around items-center"
      >
        <ul className="divide-y lg:divide-x lg:divide-y-0 divide-slate-100 lg:divide-slate-100 bg-primary lg:bg-slate-300 text-center flex flex-col lg:flex-row justify-center items-start lg:items-center w-full lg:w-[88%]">
          <li className="hidden lg:flex p-2 justify-center lg:justify-around items-center bg-secondary lg:bg-slate-300 w-full">
            <button
              onClick={() => (sideMenu.current.style.display = "block")}
              className="flex justify-center items-center"
            >
              <AiOutlineBars size="20" />
              <span className="p-2 text-sm">All Categories</span>
              <AiOutlineDownSquare size="20" />
            </button>
          </li>
          <NavLink to="/" className="header-navlink" onClick={menuToggler}>
            HOME
          </NavLink>
          <NavLink
            to={`/shop/category`}
            className="header-navlink"
            onClick={menuToggler}
          >
            SHOP
          </NavLink>
          <NavLink to="/blog" className="header-navlink" onClick={menuToggler}>
            BLOG
          </NavLink>
          <NavLink
            to={`/services/category`}
            className="header-navlink"
            onClick={menuToggler}
          >
            HIRE
          </NavLink>
          <NavLink
            to="/packages"
            className="header-navlink"
            onClick={menuToggler}
          >
            PACKAGES
          </NavLink>
          <NavLink
            to="/orders"
            className="header-navlink"
            onClick={menuToggler}
          >
            Orders
          </NavLink>
          <NavLink
            to="/bookings"
            className="header-navlink"
            onClick={menuToggler}
          >
            Bookings
          </NavLink>
        </ul>
      </div>
      {/* categories side menu */}
      <div
        ref={sideMenu}
        className="p-10 text-white font-primary bg-primary h-full absolute bottom-0 hidden"
      >
        <div className="flex justify-between items-center mb-6 pr-2 pl-2 pt-4 pb-4 bg-secondary text-black font-semibold">
          <h3>All Categories</h3>
          <button
            className="pl-2"
            onClick={() => (sideMenu.current.style.display = "none")}
          >
            <RxCross1 />
          </button>
        </div>
        <ul className="divide-y divide-slate-400">
          {props.categories.map((category) => {
            return (
              <li className="pt-6 pb-6 text-white" key={category.id}>
                <NavLink to={`/shop/${category.title}`} onClick={openCategory}>
                  {category.title} ({getNumItemsInCategory(category.title)})
                </NavLink>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default Header;
